import {FC} from 'react'
import {SAVTicketStatus} from '../../../@types'

type PropsToolbar = {
  rating: number | undefined
  status: SAVTicketStatus | undefined
}

const Toolbar: FC<PropsToolbar> = ({rating, status}) => {
  return (
    <div>
      <div className="rating d-flex justify-content-center align-items-center mb-5">
        {rating ? (
          [...Array(5)].map((_, index) => (
            <div
              className={`rating-label me-2 ${index + 1 <= rating ? "checked" : ""}`}
              key={index}
            >
              <i className="bi bi-star-fill fs-5"></i>
            </div>
          ))
        ) : <></>}

      </div>
      <div className={`badge badge-light-${status?.color} badge-lg`}>{status?.name}</div>
    </div>
  )
}

export {Toolbar}